import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { ServiceSetup } from './service-setup.service';

@NgModule({
    imports: [
        HttpModule
    ],
    providers: [
        ServiceSetup
    ],
    declarations: [],
    exports: []
})
export class CoreServicesModule { }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/core-services/core-services.module.ts